import moment from 'moment';

export const round = (number, precision) => Number(Math.round(number + "e" + precision) + "e-" + precision);

export function float(value, precision) {
    if (typeof precision == "undefined") {
        precision = 1;
    }

    if (!value || isNaN(value)) {
        return value;
    } else if (typeof value == "string") {
        value = parseFloat(value);
    }

    return value.toFixed(precision);
}

export function percent(value, decimals) {

    if (typeof decimals == "undefined") {
        decimals = 0;
    }

    return round(value * 100, decimals) + "%";
}

export function formatDate(value) 
{
    return moment(value).format('MM-DD-YYYY');
}

export function removeItemString(value)
{
    value =  value.replace("item", "");
    value =  value.replace("Item", "");
    value =  value.replace("ITEM", "");
    return value;
}

//This is for a speific thing on lead details
export function getThousands(value)
{
    var newStr = value.substring(0, value.length - 3)
    if (newStr === "")
    {
        return "0";
    }

    return newStr;
}